import React, { useState } from 'react';
import { NamedLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { getDisplayStoreDescription, getDisplayStoreName } from '../../util/store';
import { isShopNewListing } from './useShopNewBrand';
import css from './SectionShopNewBrand.module.css';

const BrandImage = ({ src, ...props }) => {
  const [failedSrc, setFailedSrc] = useState(null);
  return src && failedSrc !== src ? (
    <img {...props} src={src} onError={() => setFailedSrc(src)} />
  ) : null;
};

const SectionShopNewBrand = ({ listing, brand, compact = false }) => {
  if (!isShopNewListing(listing)) return null;
  const author = listing?.author;
  const name =
    brand?.name ||
    listing?.attributes?.publicData?.affiliateBrandName ||
    getDisplayStoreName(author);
  const bio = brand ? brand.bio : getDisplayStoreDescription(author);
  const logo =
    brand?.profileImage?.url ||
    author?.profileImage?.attributes?.variants?.['square-small2x']?.url ||
    author?.profileImage?.attributes?.variants?.['square-small']?.url;
  const rawHandle = brand
    ? brand.instagramHandle
    : author?.attributes?.profile?.publicData?.instagramHandle;
  const handle = typeof rawHandle === 'string' ? rawHandle.replace(/^@/, '') : '';
  const instagram = /^[a-zA-Z0-9._]{1,30}$/.test(handle) ? handle : null;
  if (!name && !logo && !bio) return null;
  return (
    <div className={compact ? css.compact : css.root}>
      {!compact ? (
        <BrandImage
          className={css.cover}
          src={brand?.coverImage?.url}
          alt={`${name || 'Shop New'} brand background`}
        />
      ) : null}
      <div className={css.identity}>
        <BrandImage className={css.logo} src={logo} alt={`${name || 'Shop New'} logo`} />
        <div className={css.info}>{name ? <div className={css.name}>{name}</div> : null}</div>
      </div>
      {!compact && bio ? <p className={css.bio}>{bio}</p> : null}
      {!compact ? (
        <div className={css.links}>
          {author?.id?.uuid ? (
            <NamedLink name="ProfilePage" params={{ id: author.id.uuid }}>
              <FormattedMessage id="UserCard.viewProfileLink" />
            </NamedLink>
          ) : null}
          {instagram ? (
            <a
              href={`https://www.instagram.com/${instagram}/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              @{instagram}
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default SectionShopNewBrand;
